// 직업과 서사 축 방향의 어울림 점수. 게임 규칙이며 고서의 수치가 아니다.
// 분야가 방향 분야에 있으면 +2, 직업의 갈래 성향이 방향의 성향과 하나라도 겹치면 +1 (최대 3).

export function jobFit(job, direction) {
  if (!job || !direction) return 0;
  const fieldHit = (direction.fields ?? []).includes(job.field) ? 2 : 0;
  const traits = direction.traits ?? [];
  const traitHit = traits.length && (job.branches ?? []).some((b) => traits.includes(b.trait)) ? 1 : 0;
  return fieldHit + traitHit;
}

/** 어울림이 높은 순. 동점은 입력 순서를 유지한다. 입력을 바꾸지 않는다. */
export function rankByFit(jobs, direction) {
  return jobs.map((job, order) => ({ job, fit: jobFit(job, direction), order }))
    .sort((a, b) => b.fit - a.fit || a.order - b.order)
    .map(({ job, fit }) => ({ job, fit }));
}
